import { observer } from 'mobx-react-lite'
import { Box, type IDropdownItem, Typography } from 'shared/ui'

type ILinkTriggerContentProps = {
  link: IDropdownItem | null
}
export const LinkTriggerContent = observer(({ link }: ILinkTriggerContentProps) => {
  return (
    <Box display={'flex'} justifyContent={'space-between'} gap={'2px'}>
      <Typography variant={'text-input-field-r'} ariaLabel={'linkName'} ellipsis>
        {link?.label}
      </Typography>
      <Typography
        variant={'text-input-field-r'}
        ariaLabel={'linkUrl'}
        color={'var(--content-primary-tertiary)'}
        ellipsis
      >
        {link?.labelRight}
      </Typography>
    </Box>
  )
})
